import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var MdbShortcutSvg = function MdbShortcutSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BB141A",
    fillRule: "evenodd",
    d: "M2 0h20a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H8.708A9 9 0 0 0 0 9.223V2a2 2 0 0 1 2-2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9.039 12.391V8.493H7.482l-.66 1.906q.392.25.756.538l.35-1.04v1.33a9 9 0 0 1 1.111 1.164M4.331 9.305l-.278-.812H2.487v.52a9 9 0 0 1 1.844.292M15.74 11.71c0 2.084-1.094 3.29-3.443 3.29h-1.683V8.493h.636l.288.002.296.001.53.006c2.377.045 3.375 1.21 3.375 3.208m-4.014 2.385h.589c1.337 0 2.277-.634 2.277-2.38 0-1.688-.846-2.318-2.25-2.318h-.617zm10.12-.85c0 1.188-.81 1.755-2.533 1.755h-2.327V8.493h2.236c1.652 0 2.467.603 2.467 1.7 0 .667-.297 1.144-1.162 1.481 1.058.257 1.319.905 1.319 1.57m-3.767-1.98h1.328c.599 0 1.224-.248 1.224-.932 0-.652-.549-.972-1.323-.972h-1.229zm0 2.862h1.247c.922 0 1.409-.342 1.409-.972 0-.684-.576-1.004-1.328-1.004h-1.328z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.313 23.583q-1.793 0-3.053-1.245T0 19.295q0-1.27.647-2.288a4.36 4.36 0 0 1 1.725-1.57H0V14h5.39v5.39H3.954v-2.97a2.72 2.72 0 0 0-1.797.934 2.8 2.8 0 0 0-.719 1.917q0 1.201.839 2.038a2.78 2.78 0 0 0 2.037.837z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
export var MdbShortcut = function MdbShortcut(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: MdbShortcutSvg
  }));
};